import { useEffect, useRef, useState } from 'react';
import {
  subscribeEvent,
  SocketEvent,
  unsubscribeEvent,
} from 'src/store/socket';
import { Icon } from 'src/ui/Icon';

interface SocketLog {
  level: 'info' | 'error' | 'warn' | 'highlight';
  message: string;
}

const LOG_COLOR: Record<SocketLog['level'], string> = {
  info: 'var(--green-text)',
  warn: 'var(--amber-text)',
  error: 'var(--red-text)',
  highlight: 'var(--accent-text)',
};

const AdminLogger = () => {
  const [logs, setLogs] = useState<SocketLog[]>([]);
  const logRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onNewLog = (message: SocketLog) => {
      setLogs((prev) => [...prev, message]);
      if (logRef.current) {
        logRef.current.scrollTop = logRef.current.scrollHeight;
      }
    };
    subscribeEvent(SocketEvent.ADMIN_LOG, onNewLog);
    return () => {
      unsubscribeEvent(SocketEvent.ADMIN_LOG, onNewLog);
    };
  }, []);

  return (
    <div style={{ background: 'var(--bg-canvas)' }}>
      <div
        className="row"
        style={{
          justifyContent: 'space-between',
          padding: '6px 12px',
          borderBottom: '1px solid var(--border)',
        }}
      >
        <span
          className="eyebrow row gap-2"
          style={{ fontSize: 'var(--fs-2xs)' }}
        >
          <Icon name="activity" size={12} />
          Admin log
        </span>
        <span className="text-muted" style={{ fontSize: 'var(--fs-2xs)' }}>
          {logs.length} events
        </span>
      </div>
      <div
        ref={logRef}
        className="scroll-y mono"
        style={{
          height: 100,
          padding: '8px 12px',
          fontSize: 'var(--fs-2xs)',
          lineHeight: 1.7,
          background: 'var(--bg-subtle)',
          overflowY: 'auto',
        }}
      >
        {logs.length === 0 ? (
          <span style={{ color: 'var(--text-faint)' }}>
            Waiting for events…
          </span>
        ) : (
          logs.map((log, i) => (
            <div key={i} style={{ color: LOG_COLOR[log.level] }}>
              {log.message}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AdminLogger;
